import React from 'react';
import Navbar from '../components/Navbar';
import ContentSplitSections from '../components/ContentSplitSections';
import { Link } from 'react-router-dom';
import '../styles/fire.css';
import CTASection from '../components/CTASection';

// Fire pit service sections
const firePitServices = [
  {
    title: "Custom Fire Pits",
    text: `Gathering Places That Bring Warmth to Your Landscape\n\nEvery fire pit we create is unique, designed to complement your outdoor living space and lifestyle. From rustic stone circles to modern geometric designs, we craft fire features that become the heart of your outdoor gatherings.\n\nPopular Styles:\n• Natural stone fire rings\n• Built-in seating walls\n• Sunken fire pit lounges\n• Contemporary steel and concrete designs\n• Traditional brick fire pits`,
    image: "/images/fire/customPitNight.jpg",
    alt: "Custom Fire Pit Design",
    reverse: false
  },
  {
    title: "Fire Pit Cauldron & Bowls",
    text: `Portable Elegance for Flexible Outdoor Living\n\nFor those who want the flexibility to rearrange their outdoor spaces, our caldron and bowl installations provide moveable warmth and ambiance. We ensure proper placement, safety clearances, and create beautiful surroundings that enhance these artistic fire features.\n\nFeatures & Options:\n• Copper and steel caldrons\n• Cast iron fire bowls\n• Decorative stands and bases\n• Heat-resistant patio installations\n• Safe fuel options and accessories`,
    image: "/images/fire/caldranFire.png",
    alt: "Fire Pit Caldron",
    reverse: true
  },
  {
    title: "Complete Outdoor Fire Features",
    text: `From Concept to Cozy Evenings\n\nWe don't just build fire pits – we create complete outdoor experiences. Our designs integrate seating, lighting, and landscaping to transform your backyard into a year-round entertainment destination perfect for Sun Valley's cool mountain evenings.\n\nComplete Packages Include:\n• Custom fire feature design\n• Surrounding hardscape and patio work\n• Built-in seating and tables\n• Landscape lighting integration\n• Safety features and spark screens`,
    image: "/images/fire/seatingFirePit.png",
    alt: "Complete Fire Feature",
    reverse: false
  }
];

const Fire = () => {
  return (
    <div className="fire-page">
      <Navbar />
      
      {/* Hero Section */}
      <section className="fire-hero">
        <img 
          src="/images/fire/fireHeroImage.png" 
          alt="Fire Pit at Sunset" 
          className="hero-image"
          loading="eager"
          decoding="async"
        />
        <div className="hero-overlay"></div>
        <div className="fire-hero-content">
          <h1 className="fire-hero-title">Fire Pits & Outdoor Fire Features</h1>
          <p className="fire-hero-subtitle">
            Creating gathering places that warm your evenings and extend your outdoor living season
          </p>
          <Link to="/Gallery" className="btn-cta">
           Gallery
          </Link>
        </div>
      </section>

      {/* Introduction */}
      <section className="section bg-white">
        <div className="section-inner text-center">
          <h2 className="section-title">The Ancient Art of Fire in Modern Landscapes</h2>
          <p className="intro-text">
            Fire was one of man's first tools. We still use it today to warm our homes and cook our food. 
            In our mountain and high plateau setting it is a great way to enjoy the outdoors into the 
            evening or warm us on cool clear day in the early spring or fall. We can create many types 
            of fire pits, each one with a unique style.
          </p>
          <div className="fire-services-grid">
            <div className="service-item">
              <div className="service-icon">🔥</div>
              <h3>Custom Design</h3>
              <p>Unique fire features tailored to your space</p>
            </div>
            <div className="service-item">
              <div className="service-icon">🪨</div>
              <h3>Quality Materials</h3>
              <p>Natural stone, steel, and premium hardscapes</p>
            </div>
            <div className="service-item">
              <div className="service-icon">🛡️</div>
              <h3>Safety First</h3>
              <p>Code-compliant installations with safety features</p>
            </div>
            <div className="service-item">
              <div className="service-icon">🌟</div>
              <h3>Complete Installation</h3>
              <p>From excavation to first fire</p>
            </div>
          </div>
        </div>
      </section>

      {/* Fire Pit Services */}
      <section className="section bg-warm-stone">
        <div className="section-inner">
          <h2 className="section-title text-center">Our Fire Pit Portfolio</h2>
          <p className="section-intro">Each fire feature is crafted to become the heart of your outdoor living space</p>
        </div>
      </section>
      
      <ContentSplitSections sections={firePitServices} />

      {/* Benefits Section */}
      {/* <section className="section bg-ember-gradient text-white">
        <div className="section-inner text-center">
          <h2 className="section-title">Why Add a Fire Feature?</h2>
          <div className="benefits-showcase">
            <div className="benefit-item">
              <div className="benefit-icon">🌙</div>
              <h3>Extend Your Evenings</h3>
              <p>Enjoy outdoor living well into the night</p>
            </div>
            <div className="benefit-item">
              <div className="benefit-icon">❄️</div>
              <h3>Four-Season Comfort</h3>
              <p>Warmth for cool mountain mornings and evenings</p>
            </div>
            <div className="benefit-item">
              <div className="benefit-icon">👥</div>
              <h3>Natural Gathering Place</h3>
              <p>Create memories around the fire</p>
            </div>
            <div className="benefit-item">
              <div className="benefit-icon">💎</div>
              <h3>Increase Property Value</h3>
              <p>A premium feature buyers love</p>
            </div>
          </div>
        </div>
      </section> */}

      {/* Materials & Options */}
      <section className="section bg-white">
        <div className="section-inner">
          <h2 className="section-title text-center">Materials & Design Options</h2>
          <div className="materials-grid">
            <div className="material-card">
              <h3>Natural Stone</h3>
              <ul>
                <li>Idaho moss rock</li>
                <li>Flagstone caps</li>
                <li>River rock</li>
                <li>Lava rock</li>
              </ul>
            </div>
            <div className="material-card">
              <h3>Metal Features</h3>
              <ul>
                <li>Steel fire rings</li>
                <li>Copper bowls</li>
                <li>Cast iron grates</li>
                <li>Spark screens</li>
              </ul>
            </div>
            <div className="material-card">
              <h3>Fuel Options</h3>
              <ul>
                <li>Natural wood burning</li>
                <li>Natural gas lines</li>
                <li>Propane systems</li>
                <li>Decorative glass</li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* Service Area */}
      <section className="section bg-bark text-white">
        <div className="section-inner text-center">
          <h2 className="section-title">Warming the Wood River Valley</h2>
          <div className="service-areas">
            <div className="area-item">
              <h3>Sun Valley</h3>
              <p>Resort & luxury homes</p>
            </div>
            <div className="area-item featured">
              <h3>Ketchum</h3>
              <p>Mountain residences</p>
            </div>
            <div className="area-item">
              <h3>Hailey</h3>
              <p>Family neighborhoods</p>
            </div>
            <div className="area-item">
              <h3>Bellevue</h3>
              <p>Ranch properties</p>
            </div>
          </div>
        </div>
      </section>

       {/* CTA Section */}
     <CTASection 
  title="Ready to Gather Around the Fire?"
  subtitle="Let's create the perfect fire feature for your outdoor space. 
            From intimate fire bowls to grand gathering places, we'll design something uniquely yours."
  galleryLink="/Gallery/landscape"
  showEmergency={true}
/>
    </div>
  );
};

export default Fire;